import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Media from 'react-media';
import { useHistory, useParams } from 'react-router-dom';

import { useUserStateDispatch } from 'contexts/auth-context';

import cn from 'classnames';

import { useUserState } from 'contexts/auth-context';
import t from 'utils/translateFunc';
import trackingEvent from 'utils/trackingEvent';

import {
  BtnPurpleTransparent32,
  BtnGreen32,
  SearchField,
  Loader,
  ModalWindow,
  TextRedactor
} from 'components/common/Elements/Elements';

import { userState } from 'contexts/actions/authActions';

import imgNotFind from 'assets/svg/notfindrelease.svg';

import ResponsReleaseBlock from './parts/ResponsReleaseBlock/ResponsReleaseBlock';
import TooltipAlert from './parts/TooltipAlert/TooltipAlert';
import useScroll from './parts/useScroll/useScroll';

import { postRequest } from 'utils/requests';

import classes from './CreateFirstRelease.module.scss';

const CreateFirstRelease = ({ mixpanel, onOfNotif }) => {
  const language = useUserState().user.language;
  const username = useUserState().user.username;
  const dispatch = useUserStateDispatch();

  const [urlInput, setUrlInput] = useState('');
  const [nameInput, setNameInput] = useState('');

  const [textInput, setTextInput] = useState('');

  // const [modalInputName, setModalInputName] = useState(false);
  const [modalInputText, setModalInputText] = useState(false);

  const [clearableUrl, setClearableUrl] = useState(false);

  const [dataForNewRelease, setDataForNewRelease] = useState();

  const [loaderData, setLoaderData] = useState(false);
  const [notFind, setNotFind] = useState(false);

  const [tooltipAlert, setTooltipAlert] = useState(false);

  const [disabledBottomPanel, setDisabledBottomPanel] = useState(true);

  const params = useParams();
  let history = useHistory();

  useEffect(() => {
    if (username) {
      mixpanel.track(`User ${username} enter Create New Release page`);
    }
    // eslint-disable-next-line
  }, [username]);

  const scroll = useScroll();
  useEffect(() => {
    setDisabledBottomPanel(
      document.documentElement.scrollHeight -
        document.documentElement.clientHeight <
        scroll + 40
    );
  }, [scroll]);

  const onSaveName = nameRelease => {
    params.groupId !== 'first'
      ? trackingEvent('create_campaign', mixpanel, username)
      : trackingEvent('create_first_campaign', mixpanel, username);

    setNameInput(nameRelease);
    saveRelease(nameRelease);
  };

  const onOpenModalEdit = () => {
    setModalInputText(!modalInputText);
  };

  const onSaveEdit = value => {
    params.groupId !== 'first'
      ? trackingEvent('save_edit_campaign', mixpanel, username)
      : trackingEvent('save_edit_first_campaign', mixpanel, username);
    setDataForNewRelease({ ...dataForNewRelease, articleText: value });
    setModalInputText(false);
  };

  const onClear = () => {
    params.groupId !== 'first'
      ? trackingEvent('clear_search_campaign', mixpanel, username)
      : trackingEvent('clear_search_first_campaign', mixpanel, username);
    setNotFind(false);
    setUrlInput('');
    setNameInput('');
    setTooltipAlert(false);
    setTextInput('');
    setDataForNewRelease();
    setClearableUrl(false);
  };

  const handleUrl = e => {
    setUrlInput(e.target.value);
    setClearableUrl(false);
    setNotFind(false);
    setTooltipAlert(false);
  };

  const handleTextInput = e => {
    setTextInput(e.target.value);
  };

  const onSubmitSearh = e => {
    e.preventDefault();
    if (!tooltipAlert) {
      setLoaderData(true);
      setClearableUrl(true);

      const url = `/api/press-releases/action/article-search`;

      const REQ_BODY = urlInput
        ? {
            url: urlInput.trim()
          }
        : {
            text: textInput
          };

      postRequest(url, REQ_BODY)
        .then(res => {
          setDataForNewRelease(res);
          if (urlInput === '') {
            setUrlInput(res.url);
          }
          setLoaderData(false);
          setDisabledBottomPanel(
            document.documentElement.scrollHeight -
              document.documentElement.clientHeight <
              scroll + 40
          );
        })
        .catch(err => {
          if (textInput.length === 0) {
            setNotFind(true);
          } else {
            setNotFind(true);
            setTooltipAlert(true);
          }
          console.log(err);
          setLoaderData(false);
        });
    } else {
      // onAddNewRelease();
    }
  };

  const onCancel = () => {
    params.groupId !== 'first'
      ? trackingEvent('cancel_add_campaign', mixpanel, username)
      : trackingEvent('cancel_add_first_campaign', mixpanel, username);

    history.push(
      params.groupId !== 'first' ? `/groups/${params.groupId}` : `/groups`
    );
  };

  const saveRelease = nameRelease => {
    const url = `/api/press-releases/`;

    const REQ_BODY = !tooltipAlert
      ? {
          articleDate: dataForNewRelease.articleDate,
          title: nameRelease,
          articleText: dataForNewRelease.articleText,
          articleTitle: dataForNewRelease.articleTitle,
          articleUrl: dataForNewRelease.articleUrl,
          totalAttendance: dataForNewRelease.totalAttendance,
          totalAverageAttendance: dataForNewRelease.totalAverageAttendance,
          totalViewsCount: dataForNewRelease.totalViewsCount,
          articleIds: dataForNewRelease.articleIds,
          articleId: dataForNewRelease.articleId,
          group: params.groupId !== 'first' ? params.groupId : ''
        }
      : {
          title: nameRelease.name,
          articleText: textInput,
          articleTitle: nameRelease.title,
          group: params.groupId !== 'first' ? params.groupId : ''
        };
    postRequest(url, REQ_BODY)
      .then(res => {
        mixpanel.track(`User ${username} save new release`);
        setDataForNewRelease(res);
        setLoaderData(false);
        history.push(`/groups/${res.group}/${res.id}`);
        onOfNotif(
          'on',
          params.groupId !== 'first'
            ? t('notif', 'OPTION_ADDED', language)
            : t('notif', 'CAMPAIGN_ADDED', language),
          false,
          '2000'
        );
      })
      .catch(err => {
        if (err.response.status === 400) {
          userState({
            error: 400
          })(dispatch);
          history.push(`/groups`);
        }
        setLoaderData(false);
      });
  };

  const onClickEdit = () => {
    params.groupId !== 'first'
      ? trackingEvent('open_edit_campaign', mixpanel, username)
      : trackingEvent('open_edit_first_campaign', mixpanel, username);
    onOpenModalEdit();
  };

  return (
    <>
      <ModalWindow
        headerText={t('createFirstRelease', 'EDIT_TEXT', language)}
        isOpen={modalInputText}
        setIsOpen={() => {
          params.groupId !== 'first'
            ? trackingEvent('cancel_edit_campaign', mixpanel, username)
            : trackingEvent('cancel_edit_first_campaign', mixpanel, username);
          onOpenModalEdit();
        }}
      >
        <TextRedactor
          value={
            dataForNewRelease && dataForNewRelease.articleText
              ? dataForNewRelease.articleText
              : ''
          }
          textarea
          onCancel={() => {
            params.groupId !== 'first'
              ? trackingEvent('cancel_edit_campaign', mixpanel, username)
              : trackingEvent('cancel_edit_first_campaign', mixpanel, username);
            onOpenModalEdit();
          }}
          onClickOk={onSaveEdit}
        />
      </ModalWindow>
      <div className={classes.container}>
        <div className={classes.createFirstRelease}>
          <h2 className={classes.title}>
            {params.groupId !== 'first'
              ? t('createFirstRelease', 'ADD_NEW_VERSION', language)
              : t('createFirstRelease', 'CREATE_RELEASE', language)}
          </h2>
          <SearchField
            className={classes.search}
            value={urlInput}
            onSubmit={e => {
              params.groupId !== 'first'
                ? trackingEvent('search_url_campaign', mixpanel, username)
                : trackingEvent(
                    'search_url_first_campaign',
                    mixpanel,
                    username
                  );

              onSubmitSearh(e);
            }}
            onClear={onClear}
            onChange={handleUrl}
            type={'submit'}
            isClearabled={clearableUrl}
          />

          {!dataForNewRelease && !loaderData && !notFind ? (
            <p className={classes.subtitle}>
              {t('createFirstRelease', 'ADD_TEXT', language)}
            </p>
          ) : loaderData ? (
            <p className={classes.subtitle}>
              {t('createFirstRelease', 'SEARCHING_RELEASE', language)}
            </p>
          ) : !notFind ? (
            <p className={classes.subtitle}>
              {t('createFirstRelease', 'FOUND', language)}
            </p>
          ) : (
            <p className={classes.subtitle}>
              {!tooltipAlert
                ? t('createFirstRelease', 'NOT_FOUND', language)
                : t('createFirstRelease', 'NOT_FOUND_TEXT', language)}
            </p>
          )}

          {!dataForNewRelease && !loaderData ? (
            <form
              onSubmit={onSubmitSearh}
              className={cn(
                classes.addForm,
                tooltipAlert && classes.addForm_tooltipAlert
              )}
            >
              <textarea
                className={cn(
                  classes.textarea,
                  !tooltipAlert && classes.textarea_noTooltipAlert
                )}
                value={textInput}
                onChange={handleTextInput}
                placeholder={t('createFirstRelease', 'TEXT', language)}
              />
              {!tooltipAlert && (
                <div className={classes.buttonBox}>
                  <BtnPurpleTransparent32
                    textButton={t('createFirstRelease', 'CANCEL', language)}
                    onClick={onCancel}
                    className={classes.cancelButton}
                  />
                  <BtnGreen32
                    textButton={
                      !tooltipAlert
                        ? t('createFirstRelease', 'SEARCH', language)
                        : t('createFirstRelease', 'SAVE', language)
                    }
                    onClick={e => {
                      params.groupId !== 'first'
                        ? !tooltipAlert
                          ? trackingEvent(
                              'search_text_campaign',
                              mixpanel,
                              username
                            )
                          : trackingEvent(
                              'save_text_campaign',
                              mixpanel,
                              username
                            )
                        : !tooltipAlert
                        ? trackingEvent(
                            'search_text_first_campaign',
                            mixpanel,
                            username
                          )
                        : trackingEvent(
                            'save_text_first_campaign',
                            mixpanel,
                            username
                          );

                      onSubmitSearh(e);
                    }}
                    type={'submit'}
                    className={!tooltipAlert && classes.searchButton}
                  />
                </div>
              )}
              {tooltipAlert && (
                <Media
                  queries={{
                    large: '(min-width: 1280px)'
                  }}
                >
                  {matches => (
                    <>
                      <div className={classes.tooltipAlert}>
                        {tooltipAlert && <TooltipAlert />}
                      </div>
                      {matches.large && !disabledBottomPanel && (
                        <div className={classes.whiteBlock}></div>
                      )}
                      <TextRedactor
                        className={classes.textRedactor_tooltipAlert}
                        value={nameInput}
                        newClearRelease={tooltipAlert}
                        onCancel={onCancel}
                        onClickOk={onSaveName}
                        headerText={t(
                          'createFirstRelease',
                          'ADD_TITLE_HEADING',
                          language
                        )}
                        disabledBottomPanel={
                          matches.large ? disabledBottomPanel : true
                        }
                      />
                    </>
                  )}
                </Media>
              )}
            </form>
          ) : loaderData ? (
            <Loader />
          ) : !notFind ? (
            <>
              <Media
                queries={{
                  large: '(min-width: 1280px)'
                }}
              >
                {matches => (
                  <>
                    <ResponsReleaseBlock
                      data={dataForNewRelease}
                      onCancel={onClear}
                      headerText={
                        params.groupId !== 'first'
                          ? t(
                              'createFirstRelease',
                              'ADD_VERSION_TITLE',
                              language
                            )
                          : t('createFirstRelease', 'ADD_TITLE', language)
                      }
                      onClickOk={onSaveName}
                      nameInput={nameInput}
                      newClearRelease={tooltipAlert}
                      disabledBottomPanel={
                        matches.large ? disabledBottomPanel : true
                      }
                      onClickEdit={onClickEdit}
                    />

                    {matches.large && (
                      <div className={classes.tooltipAlert}>
                        <TooltipAlert redactor onClickEdit={onClickEdit} />
                      </div>
                    )}
                  </>
                )}
              </Media>
            </>
          ) : (
            <div className={classes.notFindWrap}>
              <img src={imgNotFind} alt="logo" width="256" height="228" />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

CreateFirstRelease.propTypes = {
  onOfNotif: PropTypes.func,
  mixpanel: PropTypes.object
};

export default CreateFirstRelease;
